import { useEffect, useState } from 'react';
import { billingApi } from '../../../api/billingApi';
import {
  computePaymentMethods,
  PaymentMethodView
} from '../components/PaymentMethodsSelector';

/**
 * Lee la config de métodos de pago desde el adaptador billingApi (lealify-base) y
 * devuelve la lista efectiva de métodos. Si la lectura falla, cae a los valores
 * por defecto (no deja al usuario sin opciones de pago).
 */
export function usePaymentMethods(): { methods: PaymentMethodView[]; loading: boolean } {
  const [methods, setMethods] = useState<PaymentMethodView[]>(() => computePaymentMethods());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { methods: cfg } = await billingApi.getPaymentMethods();
        if (active) setMethods(computePaymentMethods(cfg));
      } catch (e) {
        console.error('usePaymentMethods:', e);
        if (active) setMethods(computePaymentMethods());
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return { methods, loading };
}
